@if (devBarService.canUseDevBar()) {
	<div
		class="dev-bar-container"
		[class.open]="!devBarService.isCollapsed()"
		[class.building]="isBuilding()"
		[class.transparent]="devBarService.isTransparent()"
		(mouseenter)="devBarService.isCollapsed.set(false)"
		(mouseleave)="onMouseLeave()"
	>
		<div class="dev-bar-tab">
			<div
				class="build-dot"
				[class.building]="isBuilding()"
				[style.background]="buildStatusColor()"
			></div>
			<mat-icon>developer_mode</mat-icon>
			@if (devBarService.environmentSettings()?.shortName) {
				<span class="env-label">{{
					devBarService.environmentSettings()?.shortName
				}}</span>
			}
		</div>
		<div class="dev-bar-panel">
			<div class="panel-inner" [style.border-top]="borderBottomStyle()">
				<div class="panel-header">
					<span class="panel-title">Dev Tools</span>
					@if (isBuilding()) {
						<span class="building-label">Building…</span>
					}
					<div
						class="build-dot"
						[class.building]="isBuilding()"
						[style.background]="buildStatusColor()"
					></div>
					<mat-icon
						class="visibility-icon"
						[class.hidden]="devBarService.isTransparent()"
						(click)="toggleTransparent()"
						>{{
							devBarService.isTransparent() ? 'visibility_off' : 'visibility'
						}}</mat-icon
					>
					<mat-icon
						class="pin-icon"
						[class.pinned]="devBarService.isFloating()"
						(click)="togglePin()"
						>push_pin</mat-icon
					>
				</div>
				<div class="panel-content">
					<div class="panel-section">
						<div class="section-label">Auto-Reload</div>
						<div class="toggle-row">
							<input
								id="dev-auto-reload"
								type="checkbox"
								[ngModel]="devBarService.isAutoReload()"
								(ngModelChange)="devBarService.setIsAutoReload($event)"
							/>
							<label for="dev-auto-reload">Auto-reload</label>
						</div>
						<div class="toggle-row" [class.row-disabled]="true">
							<input
								id="dev-keep-data"
								type="checkbox"
								[disabled]="true"
								[ngModel]="devBarService.isKeepData()"
								(ngModelChange)="devBarService.setIsKeepData($event)"
							/>
							<label for="dev-keep-data">Keep data on reload</label>
						</div>
						<button class="dev-btn" [disabled]="true" (click)="reloadApp(true)">
							Reload keeping data
						</button>
					</div>
					@if (!isHandset) {
						<div class="panel-section">
							<div class="section-label">Translation</div>
							<div class="toggle-row">
								<input
									id="dev-translate-mode"
									type="checkbox"
									[(ngModel)]="languageBridge.editMode"
								/>
								<label for="dev-translate-mode">Translation Mode</label>
							</div>
							<select class="dev-select" [(ngModel)]="languageBridge.language">
								@for (language of languages | keyvalue; track language) {
									<option [value]="language.key">
										{{ language.value.displayName }}
									</option>
								}
							</select>
						</div>
						<div class="panel-section">
							<div class="section-label">Editors</div>
							<button class="dev-btn" (click)="openMainScreenEditor()">
								Edit Screen {{ devBarService.mainScreenName() }}
							</button>
							@if (devBarService.getTopLevelProcessName()) {
								<button class="dev-btn" (click)="openMainProcessEditor()">
									Edit Process {{ devBarService.getTopLevelProcessName() }}
								</button>
							}
						</div>
						<div class="panel-section">
							<div class="section-label">Flags</div>
							<div class="toggle-row">
								<input
									id="dev-enable-everything"
									type="checkbox"
									[ngModel]="devBarService.isEnableEverything()"
									(ngModelChange)="devBarService.setIsEnableEverything($event)"
								/>
								<label for="dev-enable-everything">Enable everything</label>
							</div>
							<div class="toggle-row">
								<input
									id="dev-ignore-validations"
									type="checkbox"
									[ngModel]="devBarService.isIgnoreValidations()"
									(ngModelChange)="devBarService.setIsIgnoreValidations($event)"
								/>
								<label for="dev-ignore-validations">Ignore validations</label>
							</div>
							<div class="toggle-row">
								<input
									id="dev-home-swimlane"
									type="checkbox"
									[ngModel]="devBarService.isHomeOnSwimlaneChange()"
									(ngModelChange)="
										devBarService.setIsHomeOnSwimlaneChange($event)
									"
								/>
								<label for="dev-home-swimlane">Home on swimlane change</label>
							</div>
						</div>
						<div class="panel-section env-section">
							<div class="env-public-name">
								{{ devBarService.environmentSettings()?.publicName ?? '' }}
							</div>
							<div class="env-short-name">
								{{ devBarService.environmentSettings()?.shortName ?? '' }}
							</div>
						</div>
					}
				</div>
			</div>
		</div>
	</div>
}
